module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "create-base",
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "base-input"
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请输入文字,建议10个字以内",
      "maxlength": "10"
    },
    on: {
      "input": _vm.textChange
    },
    model: {
      value: (_vm.formData.textInput),
      callback: function($$v) {
        _vm.$set(_vm.formData, "textInput", $$v)
      },
      expression: "formData.textInput"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "base-input"
  }, [_c('el-select', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "size": "small",
      "placeholder": "请选择字体"
    },
    on: {
      "change": _vm.familyChange
    },
    model: {
      value: (_vm.formData.familyInput),
      callback: function($$v) {
        _vm.$set(_vm.formData, "familyInput", $$v)
      },
      expression: "formData.familyInput"
    }
  }, _vm._l((_vm.options), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "base-input"
  }, [_c('el-input-number', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "min": 16,
      "size": "small",
      "max": 72,
      "label": "请输入字号",
      "placeholder": ""
    },
    on: {
      "change": _vm.sizeChange
    },
    model: {
      value: (_vm.formData.sizeInput),
      callback: function($$v) {
        _vm.$set(_vm.formData, "sizeInput", $$v)
      },
      expression: "formData.sizeInput"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "base-input",
    staticStyle: {
      "width": "auto"
    }
  }, [_c('el-color-picker', {
    attrs: {
      "size": "small"
    },
    on: {
      "change": _vm.colorChange
    },
    model: {
      value: (_vm.formData.colorInput),
      callback: function($$v) {
        _vm.$set(_vm.formData, "colorInput", $$v)
      },
      expression: "formData.colorInput"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "base-input"
  }, [_c('div', {
    staticClass: "base-group"
  }, [_c('div', {
    class: {
      primary: _vm.formData.wightInput == 'bold'
    },
    on: {
      "click": function($event) {
        return _vm.wightChange('bold')
      }
    }
  }, [_vm._v("\r\n          B\r\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "last",
    class: {
      primary: _vm.formData.italicInput == 'italic'
    },
    on: {
      "click": function($event) {
        return _vm.italicChange('italic')
      }
    }
  }, [_vm._v("\r\n          /\r\n        ")])])]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "red",
      "font-size": "14px",
      "margin-top": "10px"
    }
  }, [_vm._v("注:如果mac电脑选择字体不生效,请确认电脑中是否安装此字体(在搜索中查找：字体册)")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78f6fc46","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/components/createBase.vue
// module id = 716
// module chunks = 1